import React from 'react';

export const LoadableContainer = ({
    shouldRender,
    isLoading,
    skeleton,
    children,
}) => {
    if (!shouldRender) return null;
    if (isLoading) return <>{skeleton}</>;
    return <>{children}</>;
};
